import { CSSResultGroup, html, LitElement } from 'lit';
import { customElement, property, state } from 'lit/decorators.js';
import { IconMap } from '../../icons/generated/icon-map';
import { iconStyles } from './icon.styles';
import { IconSize, IconSizeMap, IconType } from './icon.types';

@customElement('cds-icon')
export class IconElement extends LitElement {

  @property({ type: String })
  icon: IconType | undefined;

  @property({ type: Boolean })
  notHoverable = false;

  @property({ type: String })
  size: IconSize = 'm';
  
  @state()
  private iconSize = IconSizeMap[this.size];

  willUpdate() {
    this.iconSize = IconSizeMap[this.size];
  }

  updated(changedProperties: Map<string, unknown>) {
    super.updated(changedProperties);
    this.classList.add('cds-icon');
  }

  render() {
    return html`
      <svg class="cds-icon--svg" width="${this.iconSize}" height="${this.iconSize}" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
        ${this.icon ? IconMap[this.icon] : ''}
      </svg>`;
  }

  static styles: CSSResultGroup = [iconStyles];
}

declare global {
  interface HTMLElementTagNameMap {
    'cds-icon': IconElement;
  }
}
